<!--
  Copyright 2026 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<ng-container *ngIf="survey$ | async as survey">
  <div class="job-integration-editor">
    <div
      *ngFor="let integration of integrations"
      class="job-integration-editor-card"
    >
      <div class="job-integration-editor-card-row">
        <div class="job-integration-editor-card-row-content">
          <div class="job-integration-editor-card-row-title">
            {{ integration.title }}
          </div>

          <div class="job-integration-editor-card-row-subtitle">
            {{ integration.description }}
          </div>
        </div>

        <div class="job-integration-editor-card-actions">
          <ground-job-integration-control
            [surveyId]="survey.id"
            [integrationId]="integration.id"
            [job]="survey.jobs.get(jobId())"
          ></ground-job-integration-control>
        </div>
      </div>
    </div>
  </div>
</ng-container>
